import { Space, Typography } from "antd";
import React, { Component } from "react";

class BillingData extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const tableStyles = {
      width: "100%",
    };
    const rowStyles = {
      border: "1px solid #d9d9d9",
      padding: "8px 0px",
      textAlign: "left",
      paddingLeft: "8px",
      width: "50%",
    };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "start",
          width: this.props.userData.isMobile ? "100%" : "80%",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography.Title
            level={5}
            style={{
              margin: "10px 0px",
            }}
          >
            Datos de pago
          </Typography.Title>
        </div>
        <table style={tableStyles}>
          <tbody>
            <tr>
              <td style={rowStyles}>
                <Typography style={{ fontWeight: "bold" }}>
                  Forma pago:
                </Typography>
              </td>
              <td style={rowStyles}>
                <Typography>​Domiciliación bancaria​</Typography>
              </td>
            </tr>
            <tr>
              <td style={rowStyles}>
                <Typography style={{ fontWeight: "bold" }}>
                  Tipo de pago:
                </Typography>
              </td>
              <td style={rowStyles}>
                <Typography>​Pago recurrente​ </Typography>
              </td>
            </tr>
            <tr>
              <td style={rowStyles}>
                <Typography style={{ fontWeight: "bold" }}>IBAN:</Typography>
              </td>
              <td style={rowStyles}>
                <Typography>{`${this.props.userData.customer.iban}`}</Typography>
              </td>
            </tr>
            <tr>
              <td style={rowStyles}>
                <Typography style={{ fontWeight: "bold" }}>
                  BIC/SWIFT:
                </Typography>
              </td>
              <td style={rowStyles}>
                <Typography>{`${this.props.userData.customer.bic}`}</Typography>
              </td>
            </tr>
            <tr>
              <td style={rowStyles}>
                <Typography style={{ fontWeight: "bold" }}>
                  Fecha de firma:
                </Typography>
              </td>
              <td style={rowStyles}>
                <Typography>{`${this.props.userData.signature_date}`}</Typography>
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ marginTop: 4 }}>
          <Typography style={{ textAlign: "left", fontSize: 12 }}>
            Mediante la firma de esta orden de domiciliación, el deudor autoriza
            al acreedor a enviar instrucciones a la ent idad del deudor para
            adeudar su cuenta y a la entidad para efectuar los adeudos en su
            cuenta siguiendo las instrucciones del acreedor. Como parte de sus
            derechos, el deudor está legitimado al reembolso por su entidad en
            los términos y condiciones del contrato suscrito con la misma. La
            solicitud de reembolso deberá efectuarse dentro de las ocho semanas
            que siguen a la fecha de adeudo en cuenta. Puede obtener información
            adicional sobre sus derechos en su entidad financiera
          </Typography>
        </div>
      </div>
    );
  }
}

export default BillingData;



// WEBPACK FOOTER //
// ./src/views/Contract/components/BillingData.jsx